module.exports = __webpack_public_path__ + "static/illus_2-da72096b7849d85a53b7d4e843671a6f.png";